import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): string {
    if (value) {
      const hrefRegexp = /href\s*=\s*["'].+['"]/gi;

      return this.sanitizer.sanitize(SecurityContext.HTML, value.replace(hrefRegexp, ''));
    }

    return value;
  }
}
